import { BasicDetailsForm } from '@models/MLTC_R3/BasicDetails.model';
import { CoverageForm } from '@models/MLTC_R3/Coverage.model';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Step1State {
  basicDetails: BasicDetailsForm | null;
  coverage: CoverageForm | null;
}

const initialState: Step1State = {
  basicDetails: null,
  coverage: new CoverageForm(null),
};

const step1Slice = createSlice({
  name: 'MLTC-R3-Step1',
  initialState,
  reducers: {
    updateBasicDetails: (
      state,
      action: PayloadAction<BasicDetailsForm | null>
    ) => {
      state.basicDetails = action.payload;
    },
    updateCoverage: (state, action: PayloadAction<CoverageForm>) => {
      state.coverage = action.payload;
    },
  },
  extraReducers: {},
});

export const { updateBasicDetails, updateCoverage } = step1Slice.actions;

export default step1Slice.reducer;
